import React, { useState, useEffect } from 'react'
import { Menu } from '@mui/icons-material'
import { getCookie } from '../../Utils/CookieHelper'

const PROJECT_STORE_ACCESS_KEY = 'bbverse_project_store_access'

const menuItems = [
  { label: 'About BBverse', id: 'about-bbverse' },
  { label: 'Key Highlights', id: 'key-highlights' },
  { label: 'Case Studies', id: 'case-studies' },
  { label: 'Who Benefits Most', id: 'who-benefits-most' }
]

function Header({ simple, onLogin }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [canOpenProjectStore, setCanOpenProjectStore] = useState(false)

  useEffect(() => {
    console.log('Checking authentication status...')
    if (getCookie('bb_metaverse_token')) {
      sessionStorage.removeItem(PROJECT_STORE_ACCESS_KEY)
      setIsAuthenticated(true)
      //   window.location.replace('/home')
    } else if (sessionStorage.getItem(PROJECT_STORE_ACCESS_KEY) === '1') {
      setCanOpenProjectStore(true)
    }
  }, [])

  const handleLogin = () => {
    console.log('Checking authentication status...')
    if (getCookie('bb_metaverse_token')) {
      sessionStorage.removeItem(PROJECT_STORE_ACCESS_KEY)
      window.location.replace('/home')
      return;
    }
    if (canOpenProjectStore) {
      window.location.href = '/store'
      return;
    }
    if (onLogin) {
      onLogin()
    } else {
      // window.location.href = '/'
      alert('Login function not provided. Please implement the onLogin prop.')
    }
  }

  return (
    <header
      style={{
        backgroundColor: 'transparent',
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingLeft: 'max(20px, calc((100% - 1200px) / 2))',
        paddingRight: 'max(20px, calc((100% - 1200px) / 2))',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        backdropFilter: 'blur(10px)'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <img
          src='https://res.cloudinary.com/dxbjbkvm8/image/upload/v1770105493/Group_14_idyz5u.png'
          alt='Balfour Beatty verse'
          style={{
            height: '40px',
            width: 'auto'
          }}
        />
      </div>

      <div
        style={{
          display: simple ? 'none' : 'flex',
          alignItems: 'center',
          gap: '20px',
          position: 'relative'
        }}
      >
        <button
          onClick={() => window.open('https://forms.office.com/e/hnzxMZbBSK', '_blank')}
          style={{
            backgroundColor: 'transparent',
            color: '#ffffff',
            border: 'none',
            padding: '10px 20px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'color 0.3s ease',
            fontFamily: "'Univers', 'Roboto Condensed', sans-serif"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#0ea5e9'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '#ffffff'
          }}
        >
          Contact Us
        </button>

        <button
          onClick={handleLogin}
          style={{
            backgroundColor: '#ffffff',
            color: '#0b1324',
            border: '1px solid #ffffff',
            borderRadius: '24px',
            padding: '10px 24px',
            fontSize: '14px',
            fontWeight: '700',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            fontFamily: "'Univers', 'Roboto Condensed', sans-serif",
            minWidth: '100px',
            justifyContent: 'center'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#e2e8f0'
            e.currentTarget.style.borderColor = '#e2e8f0'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#ffffff'
            e.currentTarget.style.borderColor = '#ffffff'
          }}
        >
          {isAuthenticated ? 'My Projects' : canOpenProjectStore ? 'Project Store' : 'Login'}
        </button>

        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{
            background: '#0ea5e9',
            color: '#ffffff',
            border: '1px solid #0ea5e9',
            borderRadius: '24px',
            padding: '10px 24px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'all 0.3s ease',
            fontFamily: "'Univers', 'Roboto Condensed', sans-serif",
            minWidth: '100px',
            justifyContent: 'center'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#0284c7'
            e.currentTarget.style.borderColor = '#0284c7'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#0ea5e9'
            e.currentTarget.style.borderColor = '#0ea5e9'
          }}
        >
          {isMenuOpen ? (
            'Close X'
          ) : (
            <>
              Menu
              <Menu style={{ fontSize: '20px' }} />
            </>
          )}
        </button>

        {isMenuOpen && (
          <div
            style={{
              position: 'absolute',
              top: 'calc(100% + 16px)',
              right: 0,
              backgroundColor: '#ffffff',
              borderRadius: '20px',
              padding: '10px',
              width: '260px',
              boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
              display: 'flex',
              flexDirection: 'column',
              zIndex: 1001,
              animation: 'fadeIn 0.2s ease-out'
            }}
          >
            {menuItems.map((item) => (
              <div
                key={item.id}
                onClick={() => {
                  const element = document.getElementById(item.id)
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' })
                    setIsMenuOpen(false)
                  }
                }}
                style={{
                  padding: '16px 20px',
                  borderBottom: '1px solid #f0f0f0',
                  cursor: 'pointer',
                  color: '#000000',
                  fontSize: '16px',
                  fontFamily: "'Univers', 'Roboto Condensed', sans-serif",
                  fontWeight: '500',
                  transition: 'color 0.2s ease, padding-left 0.2s ease',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#0ea5e9'
                  e.currentTarget.style.paddingLeft = '24px'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#000000'
                  e.currentTarget.style.paddingLeft = '20px'
                }}
              >
                {item.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </header>
  )
}

export default Header
